import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useEscortsData from '../hooks/useEscortsData';
import { useTranslation } from '../hooks/useTranslation';

const CityMenu: React.FC = () => {
  const { escorts } = useEscortsData();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  // Extract all cities from escorts, normalize and sort alphabetically
  const cities = Array.from(
    new Set(
      escorts
        .map(e => e.location && e.location.trim())
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b));

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center hover:text-pink-200 transition-colors duration-200"
      >
        <span>{t('cityMenu.citiesLabel')}</span>
        <svg className={`ml-1 h-4 w-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full left-0 mt-2 w-64 h-48 md:max-h-96 overflow-y-auto bg-white rounded-lg shadow-lg border border-gray-200 z-50">
            <div className="py-2">
              {cities.map((city, idx) => (
                <Link
                  key={city + idx}
                  to={`/location/${encodeURIComponent(city)}`}
                  className="w-full block px-4 py-2 text-sm hover:bg-pink-50 hover:text-pink-600 transition-colors text-gray-700"
                  onClick={() => setIsOpen(false)}
                >
                  {city}
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CityMenu;
